
const loadCaptchaBasic = () => import('captcha_basic').then(module => module.default);
export const basic_captcha = loadCaptchaBasic
const loadEditorChart = () => import('editor-chart').then(module => module.default);
export const chart_editor = loadEditorChart
const loadEditorFormula = () => import('editor-formula').then(module => module.default);
export const formula_editor = loadEditorFormula
const loadEmbedBasic = () => import('embed-basic').then(module => module.default);
export const basic_embed = loadEmbedBasic
const loadRenderMarkdownCodehighlight = () => import('render-markdown-codehighlight').then(module => module.default);
export const render_markdown_codehighlight = loadRenderMarkdownCodehighlight